<template>
  <!-- <v-container fill-height grid-list-xl> -->
  <v-layout justify-center wrap>
    <section
      id="aboutSectionHeader"
      style="position:relative;min-width:100vw;height:500px"
    >
      <v-img
        height="100%"
        position="center center"
        :src="require('../assets/Headers/approved-good-cause-01.jpg')"
        class="hidden-xs-only"
      />
      <v-img
        height="300"
        position="center center"
        :src="require('../assets/Headers/approved-good-cause-01.jpg')"
        class="hidden-sm-and-up"
      />
    </section>

    <v-container grid-list-xl class="pageContent" style="margin-top: 20px;">
      <v-layout column>
        <v-layout row wrap justify-space-around align-start>
          <v-flex xs12 style="text-align: center;">
            <div
              class="headline"
              style=" font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >
              Becoming a Good Cause
            </div>
          </v-flex>
          <v-flex xs12>
            <div style="margin: auto; max-width: 95%; text-align: left;">
              <h3
                style="font-family: 'Aleo' !important;font-size: 20pt !important;color: #4cc7e8;"
              >
                Download Info
                <v-btn
                  :href="
                    `https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/joinPdf%2FCharitable_Good_Cause_digital_info_flyer.pdf?alt=media&token=4236d03b-fd75-4d6c-9724-41b80a100066`
                  "
                  target="”_blank”"
                  class="info"
                  >Charitable Info Pack</v-btn
                >
                <v-btn
                  :href="
                    `https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/joinPdf%2FSchool_Good_Cause_digital_info_flyer.pdf?alt=media&token=49764d60-199a-4acf-8304-45cacaf51aa9`
                  "
                  target="”_blank”"
                  class="info"
                  >School Info Pack</v-btn
                >
              </h3>
            </div>
          </v-flex>
          <v-flex xs12 style="text-align: left">
            <div style="max-width: 95%; margin: auto;">
              <p>
                Our aim is to strengthen the wellbeing of children and young
                people in New Zealand. We are focused on empowering and
                impacting Good Causes that would use UpstreamNZ for wellbeing
                projects that impact the lives our young people.
              </p>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12 md6>
            <v-form ref="enquiryForm" style="max-width: 90%; margin: auto;">
              <v-layout wrap>
                <v-flex xs12>
                  <h4
                    style="font-family: 'Aleo' !important;font-size: 20pt !important;color: #4cc7e8;"
                  >
                    Fill in this form to apply
                  </h4>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.goodCauseName"
                    :rules="[(v) => !!v || 'Good Cause name is required']"
                    label="Good Cause Name"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.location"
                    :rules="[(v) => !!v || 'Location is required']"
                    label="Location of NZ"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="formData.enquiry_type"
                    :items="enquiries"
                    label="Good Cause Type"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.website"
                    :rules="[(v) => !!v || 'Website is required']"
                    label="Website Address"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Full name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.phone"
                    :rules="[
                      (v) => !!v || 'Mobile / Contact Number is required',
                    ]"
                    label="Mobile / Contact Number"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    label="Email"
                    :rules="[(v) => !!v || 'An email address is required']"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="formData.message"
                    :rules="[(v) => !!v || 'Message is required']"
                    label="Message"
                  ></v-textarea>
                  <!-- Reference Area -->
                  <v-flex xs12>
                    <v-select
                      v-model="formData.reference"
                      :items="selectItems"
                      label="How did you hear about us?"
                    />
                    <!-- Other Option -->
                    <v-textarea
                      v-if="formData.reference === 'Other'"
                      v-model="formData.referenceOther"
                      label="Other..."
                    ></v-textarea>
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <v-btn class="info" @click="sendEmail()">Send Enquiry</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-flex sm12 md6>
            <!-- <v-carousel hide-delimiters hide-controls class="elevation-0" interval="10000">
              <v-carousel-item
                v-for="(testimonial,i) in testimonials"
                :key="i"
                :src="testimonial.src"
                class="carouselItems"
              ></v-carousel-item>
            </v-carousel>-->
            <v-img
              style="cursor: default; height: 600px !important; margin: auto;"
              :src="require('../assets/Other/UpstreamNZ_Good_Cause.png')"
              contain
            />
          </v-flex>
          <hr style="color: black; width: 100%; margin: 20px 0 20px 0" />
          <v-flex xs12 style="text-align: center;">
            <div
              class="headline"
              style=" font-weight: bold !important;font-family: 'Aleo' !important;font-size: 30pt !important;color: black;"
            >
              Keen to know more about
            </div>
          </v-flex>
          <v-flex xs6 md4 justify-space-around style="max-height: 200px;">
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/SupplierJoin`)"
            >
              <v-img
                :src="require('../assets/Values/Approved_Supplier-04.png')"
                class="joinOptionCards"
                style=" cursor: pointer; max-height: 200px;"
                contain
              />
            </v-card>
          </v-flex>
          <v-flex xs6 md4 justify-space-around style="max-height: 200px;">
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/GoodCauseJoin`)"
            >
              <v-img
                :src="require('../assets/Values/UpstreamNZ-Badge-03.png')"
                class="joinOptionCards"
                style=" cursor: pointer; max-height: 200px;"
                contain
              />
            </v-card>
          </v-flex>
          <v-flex
            xs12
            md4
            justify-space-around
            style="max-height: 200px; margin-bottom: 20px;"
          >
            <v-card
              tile
              style="border-radius: 0 !important; box-shadow: none !important; background: none;"
              @click="$router.push(`/ImpactBusinessJoin`)"
            >
              <v-img
                :src="require('../assets/Values/UpstreamNZ Badges-05.png')"
                class="joinOptionCards"
                style=" cursor: pointer; max-height: 200px;"
                contain
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-dialog v-model="emailFormConfirmation" max-width="350px">
        <v-card>
          <v-card-text>
            <p v-if="formData.enquiry_type == 'business'">
              Thank you for requesting an information pack about being an
              UpstreamNZ business. We will send one to this address ASAP.
            </p>
            <p v-else-if="formData.enquiry_type == 'goodcause'">
              Thank you for enquiring about the opportunity to know more about
              being an UpstreamNZ Good Cause. We will be in touch ASAP to
              discuss.
            </p>
            <p v-else>
              Thank you for your email. We aim to respond to all emails ASAP
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              flat
              @click="emailFormConfirmation = false"
              >Close</v-btn
            >
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    joins: [
      {
        title: "Supplier",
        background: "background: #4cc7e8;",
        link: "/SupplierJoin",
      },
      {
        title: "Good Cause",
        background: "background: #59595c;",
        link: "/GoodCauseJoin",
      },
      {
        title: "Impact Customer",
        background: "background: #4cc7e8;",
        link: "/ImpactCustomerJoin",
      },
    ],
    testimonials: [
      {
        name: "Testimonial 1",
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/testimonialImages%2FTestimonial%201.png?alt=media&token=a56dedff-7bdc-4172-99ba-5ac188b4a45f",
      },
      {
        name: "Testimonial 2",
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/testimonialImages%2FTestimonial%202.png?alt=media&token=2e8ee0f3-1b13-419e-9eec-9f86537b70c3",
      },
    ],
    formData: {
      enquiry_type: "goodcauseJoin",
    },
    enquiries: [
      {
        text: "School Based Good Cause",
        value: "goodCauseSchoolJoin",
      },
      {
        text: "Charitable Good Cause",
        value: "goodCauseCharityJoin",
      },
    ],
    emailFormConfirmation: false,
    selectItems: [
      "Another Supplier",
      "Charity Promoted",
      "Facebook",
      "Friend/Family",
      "Google Adwords",
      "Promotion Material",
      "Web Search",
      "YouTube Video",
      "Other",
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      services: "business/services",
      categories: "categories/list",
      categoriesByName: "categories/byName",
    }),
  },
  methods: {
    async sendEmail() {
      if (this.$refs.enquiryForm.validate()) {
        this.$store.dispatch(
          "emailSending/sendGoodCauseJoinEnquiry",
          this.formData
        );
        this.emailFormConfirmation = true;
      }
    },
  },
};
</script>

<style>
.application {
  background-color: white !important;
}
</style>

<style scoped>
.nl2br {
  white-space: pre-line;
}

.cardTitleHeader {
  text-align: center;
  height: 130px;
  background: #4cc7e8;
}

.carouselItems {
  width: 430px;
  height: auto;
  margin: auto;
}

@media only screen and (max-width: 445px) {
  .carouselItems {
    width: 300px !important;
    height: 350px !important;
  }
}

@media only screen and (max-width: 600px) {
  section#aboutSectionHeader {
    height: 100% !important;
  }
}

@media only screen and (min-width: 1904px) {
  .pageContent {
    max-width: 1200px;
  }
}

.display-3 {
  font-family: "Aleo" !important;
}
</style>
